export const STATUS_CARD_CONFIGS = [
  {
    title: 'Đồng bộ đơn hàng',
    icon: 'flaticon2-list-3',
    variant: 'success',
    dataKey: 'order_sync',
  },
  {
    title: 'Đồng bộ tồn kho',
    icon: 'flaticon2-box',
    variant: 'info',
    dataKey: 'inventory_sync',
  },
  {
    title: 'Hàng đợi',
    icon: 'flaticon2-layers',
    variant: 'warning',
    dataKey: 'queues',
  },
  {
    title: 'Kết nối',
    icon: 'flaticon2-link',
    variant: 'primary',
    dataKey: 'connections',
  },
]

export const CONNECTION_TABLE_FIELDS = [
  { key: 'shopName', label: 'Tên gian hàng', sortable: true },
  { key: 'platform', label: 'Sàn', sortable: false },
  { key: 'status', label: 'Trạng thái', sortable: false },
  { key: 'createdAt', label: 'Ngày kết nối', sortable: true },
  { key: 'actions', label: '', thStyle: { width: '80px' } },
]

export const CONNECTION_STATUS_MAP = {
  connected: { variant: 'success', text: 'Đã kết nối' },
  disconnected: { variant: 'danger', text: 'Mất kết nối' },
  pending: { variant: 'warning', text: 'Đang kết nối' },
}

/** Bố cục cột: meta dòng 1; ID → SP → KH → Thông tin → Trạng thái → Thanh toán → Actions */
export const ORDER_LOG_FIELDS = [
  {
    key: 'selectRow',
    label: '',
    sortable: false,
    thStyle: { width: '40px', minWidth: '40px', maxWidth: '44px' },
    tdClass: 'text-center',
  },
  {
    key: 'orderId',
    label: 'ID',
    sortable: true,
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: { width: '72px', minWidth: '64px', maxWidth: '88px' },
  },
  {
    key: 'productCombined',
    label: 'Sản phẩm',
    sortable: false,
    thStyle: { width: '28%' },
  },
  {
    key: 'buyerInfo',
    label: 'Khách hàng',
    sortable: false,
    thStyle: { width: '14%', minWidth: '140px' },
  },
  {
    key: 'infoBlock',
    label: 'Thông tin',
    sortable: false,
    thStyle: { width: '22%' },
  },
  {
    key: 'statusCombined',
    label: 'Trạng thái',
    sortable: false,
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: { width: '11%' },
  },
  {
    key: 'paymentSummary',
    label: 'Thanh toán',
    sortable: false,
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: { width: '10%' },
  },
  {
    key: 'actions',
    label: '',
    sortable: false,
    thStyle: { width: '52px', minWidth: '48px', maxWidth: '56px' },
    thClass: 'text-center',
    tdClass: 'text-center',
  },
]

/** Cột % + colgroup; Tham chiếu vừa đủ mã đơn; ưu tiên Ghi chú dài; tổng 100% */
export const COMPLAINT_TICKET_TABLE_FIELDS = [
  {
    key: 'refs',
    label: 'Tham chiếu',
    thStyle: { width: '24%' },
  },
  {
    key: 'extra',
    label: 'Chi tiết',
    thStyle: { width: '18%' },
  },
  {
    key: 'status',
    label: 'Xử lý',
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: { width: '12%' },
  },
  {
    key: 'money',
    label: 'Thanh toán',
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: { width: '13%' },
  },
  {
    key: 'content',
    label: 'Ghi chú',
    thStyle: { width: '27%' },
  },
  {
    key: 'actions',
    label: '',
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: { width: '6%' },
  },
]

export const ORDER_STATUS_OPTIONS = [
  { value: null, text: 'Tất cả trạng thái' },
  { value: 'synced', text: 'Đã đồng bộ' },
  { value: 'failed', text: 'Thất bại' },
  { value: 'pending', text: 'Đang xử lý' },
]

export const ORDER_STATUS_FILTER_OPTIONS = [
  { value: null, text: 'Tất cả' },
  { value: 1, text: 'Mới' },
  { value: 2, text: 'Đang xử lí' },
  { value: 3, text: 'Đã xác nhận' },
  { value: 4, text: 'Đang giao' },
  { value: 5, text: 'Đang đóng gói' },
  { value: 6, text: 'Thành công' },
  { value: 18, text: 'Đang chuyển hoàn' },
  { value: 19, text: 'Chờ thu hồi' },
  { value: 20, text: 'Giao thất bại' },
  { value: 7, text: 'Không thành công' },
  { value: 8, text: 'Hệ thống hủy' },
  { value: 9, text: 'Đã chuyển hoàn' },
  { value: 10, text: 'Không bắt máy' },
  { value: 11, text: 'CR hủy' },
  { value: 12, text: 'Đã đặt cọc' },
  { value: 13, text: 'Đồng ý cọc' },
  { value: 14, text: 'Đã chuẩn bị' },
  { value: 15, text: 'Đang theo dõi' },
  { value: 16, text: 'Khách hủy' },
  { value: 17, text: 'Giữ cọc' },
]

export const EXTERNAL_STATUS_OPTIONS = [
  { value: null, text: 'Tất cả' },
  { value: 'READY_TO_SHIP', text: 'READY_TO_SHIP' },
  { value: 'RETRY_SHIP', text: 'RETRY_SHIP' },
  { value: 'PROCESSED', text: 'PROCESSED' },
  { value: 'SHIPPED', text: 'SHIPPED' },
  { value: 'TO_CONFIRM_RECEIVE', text: 'TO_CONFIRM_RECEIVE' },
  { value: 'COMPLETED', text: 'COMPLETED' },
  { value: 'CANCELLED', text: 'CANCELLED' },
  { value: 'IN_CANCEL', text: 'IN_CANCEL' },
  { value: 'TO_RETURN', text: 'TO_RETURN' },
]

/** Map Shopee externalStatus → b-badge variant + label (dùng trong OrderLogTable) */
export const EXTERNAL_STATUS_BADGE_MAP = {
  READY_TO_SHIP: { variant: 'info', text: 'READY_TO_SHIP' },
  RETRY_SHIP: { variant: 'warning', text: 'RETRY_SHIP' },
  PROCESSED: { variant: 'primary', text: 'PROCESSED' },
  SHIPPED: { variant: 'success', text: 'SHIPPED' },
  TO_CONFIRM_RECEIVE: { variant: 'info', text: 'TO_CONFIRM_RECEIVE' },
  COMPLETED: { variant: 'success', text: 'COMPLETED' },
  CANCELLED: { variant: 'danger', text: 'CANCELLED' },
  IN_CANCEL: { variant: 'warning', text: 'IN_CANCEL' },
  TO_RETURN: { variant: 'danger', text: 'TO_RETURN' },
  UNPAID: { variant: 'secondary', text: 'UNPAID' },
}

export const ORDER_STATUS_MAP = {
  synced: { variant: 'success', text: 'Đã đồng bộ' },
  success: { variant: 'success', text: 'Thành công' },
  failed: { variant: 'danger', text: 'Thất bại' },
  pending: { variant: 'warning', text: 'Đang xử lý' },
  processing: { variant: 'info', text: 'Đang xử lý' },
}

export const INVENTORY_LOG_FIELDS = [
  {
    key: 'isSyncInventory',
    label: 'Đồng bộ tồn kho',
    sortable: false,
    thStyle: { width: '10%' },
    tdClass: 'text-center',
  },
  {
    key: 'productInfo',
    label: 'Sản phẩm',
    sortable: false,
    thStyle: { width: '20%' },
  },
  {
    key: 'shopName',
    label: 'Gian hàng',
    sortable: false,
    thStyle: { width: '12%' },
  },
  {
    key: 'clickbuyStock',
    label: 'Tồn ClickBuy',
    sortable: false,
    thStyle: { width: '10%' },
    tdClass: 'text-center',
  },
  {
    key: 'syncedStock',
    label: 'Tồn đồng bộ',
    sortable: false,
    thStyle: { width: '10%' },
    tdClass: 'text-center',
  },
  {
    key: 'syncStatus',
    label: 'Trạng thái',
    sortable: false,
    thStyle: { width: '10%' },
  },
  {
    key: 'syncedAt',
    label: 'Ngày đồng bộ',
    sortable: true,
    thStyle: { width: '14%' },
  },
  {
    key: 'errorMessage',
    label: 'Lỗi',
    sortable: false,
    thStyle: { width: '15%' },
  },
  { key: 'actions', label: '', thStyle: { width: '8%' } },
]

export const INVENTORY_STATUS_OPTIONS = [
  { value: null, text: 'Tất cả trạng thái' },
  { value: 'success', text: 'Thành công' },
  { value: 'failed', text: 'Thất bại' },
  { value: 'pending', text: 'Đang xử lý' },
]

export const INVENTORY_STATUS_MAP = {
  success: { variant: 'success', text: 'Thành công' },
  failed: { variant: 'danger', text: 'Thất bại' },
  pending: { variant: 'warning', text: 'Đang xử lý' },
}
